import { useEffect, useRef, useState } from 'react';
import { t } from '../../localization/adminText';

export default function InspectorPanel({ request, children }) {
  const [narrow, setNarrow] = useState(() => window.matchMedia?.('(max-width: 1100px)').matches || false);
  const dialog = useRef(null);
  useEffect(() => {
    const media = window.matchMedia?.('(max-width: 1100px)');
    if (!media) return;
    const changed = () => setNarrow(media.matches);
    media.addEventListener('change', changed);
    return () => media.removeEventListener('change', changed);
  }, []);
  useEffect(() => {
    if (narrow && request > 0 && !dialog.current?.open) dialog.current?.showModal();
  }, [narrow, request]);
  if (!narrow) return children;
  return <dialog ref={dialog} className="cfd-inspector-drawer" aria-label={t('Form designer settings')}>
    <div className="cfd-drawer-header"><strong>{t('Edit settings')}</strong><button type="button" onClick={() => dialog.current.close()}>{t('Done')}</button></div>
    {children}
  </dialog>;
}
